import React, { useEffect, useState, useRef } from "react";
import Swal2 from "sweetalert2";
import withReactContent from "sweetalert2-react-content";
import "../styles/payments.css";
import Loading from "../helpers/loading_component.js";
import emailjs from "@emailjs/browser";
import LoadingPopup from "../helpers/loading_component.js";
import SelectSearch from "react-select-search";
import { secretKey } from "../.././data";
import Select from "react-select";

const MySwal = withReactContent(Swal2);

const AddNakDateA = (props) => {
  const [value, setValue] = useState("");
  const [loading, setLoading] = useState(false);

  const getData = () => {};

  useEffect(() => {
    getData();
  }, []);

  const editClient = async (e) => {
    if (validatePayment()) {
      setLoading(true);

      var body = {
        clientId: props.client.id,
        field: "nakDateA",
        value: value,
      };

      fetch("https://apidevkppp.ftpeople.pl/updateFieldClient", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: secretKey,
        },
        body: JSON.stringify(body),
      })
        .then((response) => response.json())
        .then((data) => {})
        .catch((error) => {});

      props.logClientAction(
        "Edytowano informację o dacie nakazu",
        props.client.id
      );

      MySwal.fire({
        icon: "success",
        title: "Edytowano",
        text: "sprawę",
      }).then(async (result) => {
        props.close();
      });
    } else {
      MySwal.fire({
        icon: "error",
        title: "Błąd",
        text: "Wypełnij wymagane pola formularza",
      });
    }
  };

  const validatePayment = (e) => {
    if (value.length > 0) {
      return true;
    } else {
      return false;
    }
  };

  return (
    <div style={{ width: "40vw" }} className="mainContainerAddClientContact">
      {loading ? (
        <LoadingPopup id={"popUpLoading"} />
      ) : (
        <>
          <div className="closeButtonAP">
            <button className="closeClientButton" onClick={props.close}>
              X
            </button>
          </div>

          <div className="inputBox">
            <div className="inputCol_1">
              <label>
                Data odebrania nakazu/wezwania do złożenia odpowiedzi na pozew{" "}
                <span className="requiredStar">*</span>
              </label>
              <input
                type="date"
                id="name"
                name="name"
                value={value ? value : props.client.nakDateA}
                onChange={(e) => setValue(e.target.value)}
              />
            </div>
          </div>

          <div className="saveBoxAP">
            <button className="paymentMenuButton" onClick={editClient}>
              zapisz
            </button>
          </div>
        </>
      )}
    </div>
  );
};

export default AddNakDateA;
